Ext.define('WindowStopManualTankTramwaje', {
    extend: 'Ext.ux.window.WindowExd',
    title: Lang.stop_manual_proces_tankowania.capitalise(),
    width: 550,
    closable: false,
    collapsible: false,
    scrollable: false,
    modal: true,
    resizable: false,
    layout: 'fit',
    initComponent: function () {
        this.cid = Ext.id();
        this.items = [{
            xtype: 'panel',
            layout: 'column',
            items: [{
                columnWidth: 1,
                xtype: 'form',
                id: this.cid + 'formpanel',
                bodyStyle: 'padding:10px 10px 10px 10px',
                scrollable: false,
                defaults: {
                    labelWidth: 150,
                    labelAlign: WindowExdMobileDEVICEV ? 'top' : 'left',
                    anchor: "0"
                },
                items: [, {
                    id: this.cid + "tor",
                    name: "tor",
                    fieldLabel: Lang.tor,
                    allowBlank: false,
                    xtype: "comboexd",
                    minChars: 1,
                    editable: true,
                    store: Ext.create('Ext.data.Store', {
                        fields: ['value'],
                        proxy: {
                            type: 'ajax',
                            url: 'rest/tramwaje/getTorForManualStartList',
                            actionMethods: {
                                read: 'POST'
                            },
                            reader: {
                                type: 'json',
                                transform: function (data) {
                                    return {
                                        data: data.map(function (item) {
                                            return {value: item};
                                        })
                                    };
                                },
                                rootProperty: 'data'
                            }
                        },
                        autoLoad: true
                    }),
                    displayField: 'value',
                    valueField: 'value',
                    forceSelection: true,
                    emptyText: '...'
                }]
            }]
        }];
        this.buttons = [{
            xtype: 'tbfill'
        }, {
            id: this.cid + 'stop',
            text: Lang.stop,
            scope: this,
            handler: this.stopOp
        }, {
            id: this.cid + 'cancel',
            text: Lang.anuluj,
            scope: this,
            handler: this.closeOp
        }];
        this.callParent(arguments);
    },
    showW: function () {
        if (!validPrivilegesOperatorComplex(ViewTramwaje.accessPropertyName)) {
            Ext.MessageBox.alert(Lang.error, Lang.brak_uprawnien_do_wykonania_operacji);
            return;
        }
        this.show();
        this.center();
    },
    stopOp: function () {
        if (!validPrivilegesOperatorComplex(ViewTramwaje.accessPropertyName)) {
            Ext.MessageBox.alert(Lang.error, Lang.brak_uprawnien_do_wykonania_operacji);
            return;
        }
        if (false === Ext.getCmp(this.cid + 'formpanel').getForm().isValid()) {
            Ext.MessageBox.alert(Lang.error, Lang.dane_niepoprawne);
            return;
        }
        sendAjaxDataJsonRpcL("rest/tramwaje/stopManualTankTramwaje", {
            tor: Ext.getCmp(this.cid + "tor").getValue(),
        }, this, function (data) {
            if (data.status) {
                Ext.MessageBox.alert(Lang.operacja, Lang.operacja_zakonczona_poprawnie);
                if (data.data != null) {
                    Ext.MessageBox.alert(Lang.operacja, Lang.operacja_zakonczona_poprawnie + " " + Lang.wylacz_tryb_manualny_brak_aktywnych_tramwajow);
                }
                this.closeOp();
            } else {
                Ext.MessageBox.alert(Lang.error, data.error);
            }
        });
    },
    closeOp: function () {
        this.close();
    }
});
